import useSWR from 'swr'
import { useRouter } from 'next/router'

import { StrapiCategoryAttribute, StrapiCategoryResp } from '../../utils/types/strapi'
import { parseAndSanitizeObject } from '../../utils/util'
import { getCountryAndLocaleStrings } from '../../utils/locales'
import { getStrapiCategoryUrl } from '../../utils/strapi'
import { strapiFetcher } from '../../utils/fetcher'

const useProductCatalogCategoryContent = (categoryCode: string) => {
  const { locale: countryAndLocaleString } = useRouter()
  const { locale } = getCountryAndLocaleStrings(countryAndLocaleString)
  const strapiUrl = getStrapiCategoryUrl(categoryCode, locale)

  // refresh on countryAndLocaleString change
  const { data } = useSWR<StrapiCategoryResp>(
    [strapiUrl, countryAndLocaleString],
    (url) => strapiFetcher(url, countryAndLocaleString),
  )

  const {
    productCatalogDescription,
    categoryPageBottom,
  } = parseAndSanitizeObject<StrapiCategoryAttribute>(
    data?.data?.[0]?.attributes || ({} as StrapiCategoryAttribute),
  )

  return { productCatalogCategoryDescription: productCatalogDescription, categoryPageBottom }
}

export default useProductCatalogCategoryContent
